/**
 * 列表行点击进入详情（2026-10-18）：整行可点，不用找右侧"详情"按钮。
 * - 点到按钮/链接/开关/复选框/下拉/输入框等交互元素时不跳转（行内操作照常）
 * - 选中文字时不跳转（方便复制）
 * - Ctrl/⌘ 点击或中键：新标签页打开
 * 用法：<Table onRow={rowLink(navigate, (r) => `/dns/records/${r.id}`)} rowClassName={ROW_LINK_CLASS} />
 */
import { userPath } from '../config/paths';

export const ROW_LINK_CLASS = 'row-link';

const INTERACTIVE = 'a,button,input,textarea,select,label,[role="button"],[role="switch"],[role="checkbox"],[role="menuitem"],'
    + '.ant-switch,.ant-checkbox-wrapper,.ant-radio-wrapper,.ant-select,.ant-dropdown-trigger,.ant-dropdown,.ant-popover,'
    + '.ant-table-selection-column,.ant-typography-copy,.ant-tag-close-icon,.ant-input-number,.ant-picker,.ant-modal,.no-row-link';

export const shouldIgnoreRowClick = (e) => {
    const target = e.target;
    if (target && target.closest && target.closest(INTERACTIVE)) return true;
    const sel = typeof window !== 'undefined' && window.getSelection ? window.getSelection() : null;
    return !!(sel && String(sel).trim());
};

/** 通用：点击时按 path 跳转（path 为空则不跳） */
export const openPath = (navigate, path, e) => {
    if (!path) return;
    const full = userPath(path);
    if (e && (e.metaKey || e.ctrlKey || e.button === 1)) {
        window.open(full, '_blank', 'noopener');
        return;
    }
    navigate(full);
};

export const rowLink = (navigate, getPath) => (record) => ({
    onClick: (e) => {
        if (shouldIgnoreRowClick(e)) return;
        openPath(navigate, getPath(record), e);
    },
    onAuxClick: (e) => {
        if (e.button === 1 && !shouldIgnoreRowClick(e)) openPath(navigate, getPath(record), e);
    },
});

export default rowLink;
